class EventAndProductCombiningTransformer {
  transform (event, foundProducts) {
    event.discountedProducts = this.mapDiscountedProducts(event.discountedProducts, foundProducts)
    event.discountedProducts = this.sortDiscountedProducts(event.discountedProducts)

    event.specialPromotions = this.mapSpecialPromotions(event.specialPromotions, foundProducts)

    return event
  }

  mapDiscountedProducts (discountedProducts, foundProducts) {
    return discountedProducts.map(discountedProduct => {
      let discountedProductChanges = foundProducts.reduce((result, foundProduct) => {
        if (foundProduct.productID !== discountedProduct.id) {
          return result
        }

        return this.getProductChanges(foundProduct)
      }, {})

      return Object.assign(discountedProduct, discountedProductChanges)
    })
  }

  mapSpecialPromotions (specialPromotions, foundProducts) {
    return specialPromotions.map(promotion => {
      if (promotion.rewards.awardedProducts) {
        console.log('mapSpecialPromotions')
        console.log(promotion)
        promotion.rewards.awardedProducts = this.mapAwardedOrPurchasedProducts(promotion.rewards.awardedProducts, foundProducts)
      }

      if (promotion.requirements.purchasedProducts) {
        promotion.requirements.purchasedProducts = this.mapAwardedOrPurchasedProducts(promotion.requirements.purchasedProducts, foundProducts)
      }

      return promotion
    })
  }

  mapAwardedOrPurchasedProducts (products, foundProducts) {
    return products.map(product => {
      let discountedProductChanges = foundProducts.reduce((result, foundProduct) => {
        if (foundProduct.productID !== product.productId) {
          return result
        }

        return this.getProductChanges(foundProduct)
      }, {})

      return Object.assign(product, discountedProductChanges)
/*      console.log('!!!!!!!!!!!!!!!!!!!!!!!mapAwardedOrPurchasedProducts')
      console.log(aa)
      return aa*/
    })
  }

  getProductChanges (foundProduct) {
    return {
      id: foundProduct.productID,
      name: foundProduct.name,
      plu: foundProduct.code,

      regularPrice: foundProduct.regionBasePrice,
      regularCustomerGroupPrice: foundProduct.regionCustomerGroupBasePrice,
      cost: foundProduct.regionCost
    }
  }

  mapProductChanges (foundProduct) {
    return {
      ...foundProduct,
      ...{
        id: foundProduct.productID || foundProduct.id,
        name: foundProduct.name,
        plu: foundProduct.code || foundProduct.plu,

        regularPrice: foundProduct.regionBasePrice || foundProduct.regularPrice,
        regularCustomerGroupPrice: foundProduct.regionCustomerGroupBasePrice || foundProduct.regularCustomerGroupPrice,
        cost: foundProduct.regionCost || foundProduct.cost
      }
    }
  }
  sortDiscountedProducts (discountedProducts) {
    return discountedProducts.sort((discountedProductA, discountedProductB) => {
      if (discountedProductA.plu < discountedProductB.plu) {
        return -1
      }
      if (discountedProductA.plu > discountedProductB.plu) {
        return 1
      }
      return 0
    })
  }
}
export default EventAndProductCombiningTransformer



// WEBPACK FOOTER //
// ./src/transformers/EventAndProductCombiningTransformer.js